<template>
  <div>
    <loadingCube v-if="!loaded_reopen || !loaded_reset" :loadingMessage="''"></loadingCube>

    <div class="row record" v-else>
      <div class="col-12">
        <b-card header="REOPEN TIMESHEET PERIOD" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <div class="col-12">
              <p class="pt-0 mb-3">Use the following tool to reopen a timesheet period.<br>
                <strong>You will only be able to reopen the latest period for a company</strong>, this can either be a fully or partially submitted instruction.<br>
                                   If you need to reopen multiple timesheet periods for a company then run this tool multiple times for the company.</p>
            </div>
            <div class="col-12">
              <ValidationObserver ref="reopenTimesheetPeriod" slim>
                <form role="form" @submit.prevent="submit_reopen" class="row">
                  <ValidationProvider rules="required" v-slot="{errors, classes}" name="Company" tag="div" class="col-md-10 form-group">
                    <label class="form-label" for="reopen_company">Company</label>
                    <multiselect v-model="reopen.company" id="reopen_company" name="reopen_company" placeholder=""
                                 :options="ms_opts.reopen_companies" :class="classes" class="requiredField" label="company_name"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <div class="col-md-5 form-group" v-if="reopen.period !== null">
                    <label class="form-label" for="reopen_period_end">Timesheet period ending date</label>
                    <p id="reopen_period_end">{{ reopen.period }}</p>
                  </div>
                  <div class="col-md-5" v-else></div>
                  <div class="col-md-5 form-group" v-if="reopen.period_total !== null">
                    <label class="form-label" for="reopen_period_total">Timesheet period total</label>
                    <p id="reopen_period_total">{{ reopen.period_total }}</p>
                  </div>
                  <div class="col-md-5" v-else></div>

                  <div class="col-md-2 form-group">
                    <button :disabled="action || reopen.company === null" class="btn orcaBtn danger sm_btn w-100" type="submit">
                      <span v-if="action" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Reopening ...</span>
                      <span v-else>Reopen</span>
                    </button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-12">
        <b-card header="RESET TIMESHEET PERIOD SUBMISSIONS" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <div class="col-12">
              <p class="pt-0 mb-3">Use the following tool to reset a timesheet period.<br>
                <strong>You will only be able to reset the latest period for a company</strong>, this will be the first period that has values entered.<br>
                                   If you need to reset multiple timesheet periods for a company then run this tool multiple times for the company.</p>
            </div>
            <div class="col-12">
              <ValidationObserver ref="resetTimesheetPeriod" slim>
                <form role="form" @submit.prevent="submit_reset" class="row">
                  <ValidationProvider rules="required" v-slot="{errors, classes}" name="Company" tag="div" class="col-md-10 form-group">
                    <label class="form-label" for="reopen_company">Company</label>
                    <multiselect v-model="reset.company" id="reopen_company" name="reopen_company" placeholder=""
                                 :options="ms_opts.reset_companies" :class="classes" class="requiredField" label="company_name"></multiselect>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <div class="col-md-5 form-group" v-if="reset.period !== null">
                    <label class="form-label" for="reopen_period_end">Timesheet period ending date</label>
                    <p id="reopen_period_end">{{ reset.period }}</p>
                  </div>
                  <div class="col-md-5" v-else></div>
                  <div class="col-md-5 form-group" v-if="reset.period_total !== null">
                    <label class="form-label" for="reopen_period_total">Timesheet period total</label>
                    <p id="reopen_period_total">{{ reset.period_total }}</p>
                  </div>
                  <div class="col-md-5" v-else></div>

                  <div class="col-md-2 form-group">
                    <button :disabled="action || reset.company === null" class="btn orcaBtn danger sm_btn w-100" type="submit">
                      <span v-if="action" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Resetting ...</span>
                      <span v-else>Reset</span>
                    </button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-12" v-if="recover_timesheets.length > 0">
        <b-card header="Timesheets to recover" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
          <div class="row">
            <div class="col-12">
              <p class="pt-0 mb-3">The following timesheet periods have previously been reset - if this was done in error then you can recover the submission contents using the
                                   below.</p>
            </div>

            <div class="col-12">
              <div class="table-responsive" style="overflow: scroll; max-height: 500px; background: white">
                <table class="table table-bordered">
                  <tr>
                    <th>Company name</th>
                    <th style="max-width: 80px">Timesheet period end date</th>
                    <th>Total</th>
                    <th style="max-width: 60px">Reset date</th>
                    <th>Reset by</th>
                    <th style="max-width: 40px">Recover</th>
                  </tr>
                  <tr v-for="record in recover_timesheets">
                    <td class="pl-3 pr-3">
                      <div class="td_data_outer">
                        <div class="td_data">{{ record.company_name }}</div>
                      </div>
                    </td>
                    <td class="pl-3 pr-3">
                      <div class="td_data_outer">
                        <div class="td_data">{{ record.period_end_date }}</div>
                      </div>
                    </td>
                    <td class="pl-3 pr-3">
                      <div class="td_data_outer">
                        <div class="td_data">{{ record.total | currency }}</div>
                      </div>
                    </td>
                    <td class="pl-3 pr-3">
                      <div class="td_data_outer">
                        <div class="td_data">{{ record.reset_date }}</div>
                      </div>
                    </td>
                    <td class="pl-3 pr-3">
                      <div class="td_data_outer">
                        <div class="td_data">{{ record.reset_by }}</div>
                      </div>
                    </td>
                    <td class="pl-3 pr-3">
                      <div class="td_data_outer">
                        <div class="td_data"><button class="btn orcaBtn danger sm_btn" @click="recover_timesheet(record)">Recover</button></div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import Multiselect from "vue-multiselect";

export default {
  name: "reopen_reset",
  components: {
    loadingCube,
    Multiselect
  },
  data() {
    return {
      loaded_reopen: false,
      loaded_reset: false,
      ms_opts: {
        reopen_companies: [],
        reset_companies: []
      },
      reopen: {
        enabled: true,
        company: null,
        period: null,
        period_total: null
      },
      reset: {
        enabled: true,
        company: null,
        period: null,
        period_total: null
      },
      recover_timesheets: [],
      refresh: false, // get next submission date
      action: false, // submit form in progress
    }
  },
  beforeMount() {
    this.get_reopen_companies()
    this.get_reset_companies()
    this.get_recover_timesheets()
  },
  methods: {
    get_reopen_companies() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'timesheet/record/reopen/get_companies_submitted')
             .then(data => {
               this.ms_opts.reopen_companies = data.data;
               this.ms_opts.reset_companies = data.data;
               this.loaded_reopen = true
               resolve()
             })
      })
    },
    submit_reopen() {
      this.$refs.reopenTimesheetPeriod.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.reopenTimesheetPeriod);
        }
        else {
          this.action = true
          this.$snotify.confirm('', '', {
            closeOnClick: false,
            position: 'centerCenter',
            backdrop: 0.5,
            html: '<div class="snotifyToast__title">Confirm timesheet period reopen</div>' +
                '<div class="snotifyToast__body">' +
                'Are you sure that you want to reopen this timesheet period?<br>If this is done by mistake then a client can close a period within their portal.<br><br>' +
                '<strong>' + this.reopen.company.company_name + '</strong><br><br>' +
                '<strong style="min-width: 100px;display: inline-block">Period end:</strong> ' + this.reopen.period + '<br>' +
                '<strong style="min-width: 100px;display: inline-block">Period total:</strong>' + this.reopen.period_total + '<br>' +
                '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                '</div>',
            buttons: [
              {
                text: 'Ok', action: (toast) => {
                  axios.post(this.crmApiPath + 'timesheet/record/reopen/timesheet_period', {
                    company_id: this.reopen.company.company_id,
                    for_work_end_week_date: this.reopen.company.for_work_end_week_date
                  }).then(() => {
                    this.$snotify.remove(toast.id);
                    this.loaded_reopen = false
                    this.reopen.company = null
                    this.get_reopen_companies().then(() => this.action = false)
                  })
                }
              },
              {
                text: 'Cancel', action: (toast) => {
                  this.action = false
                  this.$snotify.remove(toast.id)
                }
              }
            ]
          })
        }
      })
    },
    get_reset_companies() {
      return new Promise(resolve => {
        this.loaded_reset = true;
        resolve();
      })
    },
    submit_reset() {
      this.$refs.resetTimesheetPeriod.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.resetTimesheetPeriod);
        }
        else {
          this.action = true
          this.$snotify.confirm('', '', {
            closeOnClick: false,
            position: 'centerCenter',
            backdrop: 0.5,
            html: '<div class="snotifyToast__title">Confirm timesheet period reset</div>' +
                '<div class="snotifyToast__body">' +
                '<span class="red_color">Are you sure that you want to reset this timesheet period?</span><br><br>' +
                '<strong>' + this.reset.company.company_name + '</strong><br><br>' +
                '<strong style="min-width: 100px;display: inline-block">Period end:</strong> ' + this.reset.period + '<br>' +
                '<strong style="min-width: 100px;display: inline-block">Period total:</strong>' + this.reset.period_total + '<br>' +
                '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                '</div>',
            buttons: [
              {
                text: 'Ok', action: (toast) => {

                  axios.post(this.crmApiPath + 'timesheet/record/reset/timesheet_period', {
                    company_id: this.reset.company.company_id,
                    for_work_end_week_date: this.reset.company.for_work_end_week_date,
                    user_id: this.$store.state.auth.me.id
                  }).then(() => {
                    this.$snotify.remove(toast.id);
                    this.loaded_reset = false
                    this.reset.company = null
                    this.get_recover_timesheets().then(() => {
                      this.get_reset_companies().then(() => this.action = false)
                    })
                  })
                }
              },
              {
                text: 'Cancel', action: (toast) => {
                  this.action = false
                  this.$snotify.remove(toast.id)
                }
              }
            ]
          })
        }
      })
    },
    get_recover_timesheets() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'timesheet/record/recover/index').then(records => {
          this.recover_timesheets = records.data
          resolve()
        })
      })
    },
    recover_timesheet(record) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm timesheet recovery</div>' +
            '<div class="snotifyToast__body">' +
            '<span class="red_color">Are you sure that you want to recover the following timesheet period for this company?</span><br><br>' +
            '<strong>' + record.company_name + '</strong><br><br>' +
            '<strong style="min-width: 100px;display: inline-block">Period end date:</strong>' + record.period_end_date + '<br>' +
            '<strong style="min-width: 100px;display: inline-block">Total:</strong>' + this.$options.filters.currency(record.total) + '<br>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Ok', action: (toast) => {
              axios.post(this.crmApiPath + 'timesheet/record/recover/company/timesheet_period', {
                company_id: record.company_id,
                period_end_date: record.period_end_date
              }).then(() => {
                this.$snotify.remove(toast.id)
                this.recover_timesheets = []
                this.get_recover_timesheets().then(() => {
                  this.reopen.company = null
                  this.loaded_reopen = false
                  this.reset.company = null
                  this.loaded_reset = false
                  this.get_reopen_companies().then(() => {
                    this.get_reset_companies()
                  })
                })
              })
            }
          },
          {
            text: 'Cancel', action: (toast) => this.$snotify.remove(toast.id)
          }
        ]
      })
    }
  },
  watch: {
    'reopen.company'(company) {
      this.reopen.period = null
      this.reopen.period_total = null
      if (this.loaded_reset && this.loaded_reopen) {
        this.$nextTick(() => this.$refs.reopenTimesheetPeriod.reset())
      }
      if (company !== null) {
        // format data to show on template
        this.reopen.period = this.$options.filters.formatDate(this.reopen.company.for_work_end_week_date)
        this.reopen.period_total = this.$options.filters.currency(this.reopen.company.period_total_pay_amount)
        // clear reset values as using reopen
        this.reset.company = null
      }
    },
    'reset.company'(company) {
      this.reset.period = null
      this.reset.period_total = null
      if (this.loaded_reset && this.loaded_reopen) {
        this.$nextTick(() => this.$refs.resetTimesheetPeriod.reset())
      }
      if (company !== null) {
        // format data to show on template
        this.reset.period = this.$options.filters.formatDate(this.reset.company.for_work_end_week_date)
        this.reset.period_total = this.$options.filters.currency(this.reset.company.period_total_pay_amount)
        // clear reopen values as using reset
        this.reopen.company = null
      }
    }
  }
}
</script>

<style scoped>

</style>
